module.exports = __webpack_public_path__ + "img/icon-check@3x.0e67fc0c.png";